import type { App } from 'vue'
import { Provider, type RealtimePluginOptions } from './RealtimePluginOptions'
import { type IProviderService } from './provider/IProviderService'
import { PusherService } from './provider/pusher/PusherService'
import { CentrifugoService } from './provider/centrifugo/CentrifugoService'
import { setInstance, tabUuid } from './realtimeInstance'
import { usePrevioRealtime } from './usePrevioRealtime'

function createService(config: RealtimePluginOptions): IProviderService {
  switch (config.provider) {
    case Provider.PUSHER:
      return new PusherService()
    case Provider.CENTRIFUGO_DEV_ONLY:
      return new CentrifugoService()
  }
}

const RealtimePlugin = {
  install(app: App, config?: RealtimePluginOptions) {
    if (!config) {
      throw new Error(
        'RealtimePlugin requires options. Use: app.use(RealtimePlugin, { provider, dsn })',
      )
    }

    usePrevioRealtime().disconnect()

    const service = createService(config)
    setInstance(service)
    service.init(config, tabUuid)
  },
}

export { RealtimePlugin }
